$(function(){
  return $(".show_notes").click(function() {
      $('.bd-example-modal-sm').modal('show')
    });
});
